"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTokenizer = void 0;
const http_client_1 = require("./http-client");
const rangeTokenizer = require("@tokenizer/range");
/**
 * Create and initialize the HTTP tokenizer
 * @param url URL to resource to stream with tokenizer
 * @param tokenizerConfig Tokenizer configuration options
 * @param httpClientConfig HTTP client configuration options
 * @return Tokenizer
 */
function makeTokenizer(url, tokenizerConfig, httpClientConfig) {
    const httpClient = new http_client_1.HttpClient(url, httpClientConfig);
    return rangeTokenizer.tokenizer(httpClient, tokenizerConfig);
}
exports.makeTokenizer = makeTokenizer;
